import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GBMMessageItemModel } from '@boxx/messages-core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-gbm-item-open',
  templateUrl: './gbm-item-open.component.html',
  styleUrls: ['./gbm-item-open.component.scss'],
})
export class GbmItemOpenComponent implements OnInit, OnDestroy {
  @Input() messageList: GBMMessageItemModel[] = [GBMMessageItemModel.empty()];
  @Input() isDetailView: boolean;

  chatMessage = '';

  constructor() {}

  ngOnInit() {
    /* const el = document.getElementById('detail-chat-container');

      if (el && response.length > this.gbmList.length) {
        this.chatMessage = '';

        setTimeout(() => {
          el.scrollIntoView({ block: 'end' });
        }, 200);
      } */
  }

  ngOnDestroy() {}
}
